import _ from "lodash";
import ACTIONS from "../actions/BillingOrganizationsActions";

const initialState = {
    addNewOrg: false,
    editOrg: false,
    addOrgModalOpen: false,
    editOrgModalOpen: false,
    deleteOrgWarning: false,
    updatedOrg: false,
    orgIdForDelete: "",
    orgModalHeader: "",
    billingOrgObject: {
        orgDetail: {
            id: "",
            name: "",
            display_name: "",
            is_deleted: false,
            email: "",
            phone: "",
            created_on: "",
            modified_on: "",
        },
        orgAddress: {},
        orgBilling: {
            id: "",
            billing_a_number: "",
            location_a_number: "",
            monthly_minimum_commitment: 0,
            monthly_platform_fee: 0,
        },
    },
}


const addEditBillingOrgReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.addEditBillingOrgActionTypes.TOGGLE_ADD_BILLING_ORG_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addOrgModalOpen = !newState.addOrgModalOpen;
            // reset the form to placeholder values
            if (!newState.billingOrgObject) {
                newState.billingOrgObject = initialState.billingOrgObject;
            }

            return newState
        }

        case ACTIONS.addEditBillingOrgActionTypes.TOGGLE_EDIT_BILLING_ORG_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editOrgModalOpen = !newState.editOrgModalOpen;
            // reset the form to placeholder values
            if (!newState.editOrgModalOpen) {
                newState.billingOrgObject = initialState.billingOrgObject;
            }

            return newState
        }

        case ACTIONS.addEditBillingOrgActionTypes.OPEN_EDIT_BILLING_ORG_MODAL: {
            let newState = _.cloneDeep(state);
            newState.billingOrgObject.orgDetail = action.payload.organizationDetail;
            newState.billingOrgObject.orgAddress = action.payload.organizationAddress;
            newState.billingOrgObject.orgBilling = action.payload.organizationBilling;
            newState.editOrgModalOpen = !newState.editOrgModalOpen;

            return newState
        }

        case ACTIONS.addEditBillingOrgActionTypes.SETTING_BILLING_ORG_FORM_VALUE: {
            let newState = _.cloneDeep(state);
            newState.billingOrgObject[action.payload.change_object][action.payload.name] = action.payload.value;
            return newState
        }

        case ACTIONS.apiActionsBillingOrg.DELETE_WARNING_FOR_BILLING: {
            let newState = _.cloneDeep(state);
            newState.deleteOrgWarning = !newState.deleteOrgWarning;
            return newState;
        }


        default:
            return state;
    }
}

export default addEditBillingOrgReducer;
